/**
 * Section Domain Model
 * Represents a section within a course
 */

export class Section {
  constructor(data) {
    this.id = data.id;
    this.courseId = data.courseId;
    this.index = data.index;
    this.title = data.title;
    this.description = data.description;
    this.isLocked = data.isLocked !== undefined ? data.isLocked : true;
    this.unlockThreshold = data.unlockThreshold || 0.75;
    this.examples = data.examples || [];
    this.questions = data.questions || [];
    this.tags = data.tags || [];
  }

  /**
   * Get question by ID
   */
  getQuestionById(questionId) {
    return this.questions.find(q => q.id === questionId);
  }

  /**
   * Get question by index
   */
  getQuestionByIndex(index) {
    return this.questions.find(q => q.index === index);
  }

  /**
   * Get example by ID
   */
  getExampleById(exampleId) {
    return this.examples.find(e => e.id === exampleId);
  }

  /**
   * Convert to JSON
   */
  toJSON() {
    return {
      id: this.id,
      courseId: this.courseId,
      index: this.index,
      title: this.title,
      description: this.description,
      isLocked: this.isLocked,
      unlockThreshold: this.unlockThreshold,
      examples: this.examples,
      questions: this.questions,
      tags: this.tags,
    };
  }

  /**
   * Create from JSON
   */
  static fromJSON(json) {
    return new Section(json);
  }
}
